module.exports = __webpack_public_path__ + "static/media/ikaLogo.8f092af3.webp";